import { axiosInstance } from "./axiosInstance";

export const loyaltyService = {
    getLoyalty: async (filters) => {
        return await axiosInstance.get('/api/superadmin/loyalty', { params: filters })
    },
}